export default {
  viewModeLines: []
}
